import { Button, CircularProgress } from "@mui/material";
import { Text } from "@utils/helper";

export default function BtnBase({
  children,
  isLoading,
  disabled,
  color = "primary",
  variant = "contained",
  ...otherProps
}) {
  return (
    <Button
      size="large"
      fullWidth
      color={color}
      variant={variant}
      disableElevation
      disabled={disabled || isLoading}
      {...otherProps}
    >
      {isLoading ? <CircularProgress size={22} /> : children}
    </Button>
  );
}

export const OutlinedBtn = ({
  hidden = false,
  isLoading,
  onBtnClicked,
  text,
  center = true,
  xs = {},
  className,
}) => {
  if (hidden) return null;
  return (
    <BtnBase
      variant="outlined"
      sx={{
        width: "fit-content",
        borderRadius: "43px",
        textTransform: "capitalize",
        ...(center ? { mx: "auto" } : {}),
        ...xs,
      }}
      className={className}
      isLoading={isLoading}
      onClick={onBtnClicked}
    >
      <Text
        color="#0366FF"
        fontType="Expo_sim"
        weight={500}
        className="!top-px leading-normal"
      >
        {text}
      </Text>
    </BtnBase>
  );
};
